import commonTop from '@/components/commonTop'

export default {
  computed: {
    moduleSecondList() {
      return this.$store.getters.getSecondModuleById(this.moduleId)
    },
    moduleData() {
      return this.$store.getters.getModuleItemById(this.moduleId)
    }
  },
  components: {
    commonTop
  }
}
